import type { AudienceFilter } from "@/entities/audience"
import { SegmentedControl } from "@/shared/ui/segmented-control"
import {
	Sheet,
	SheetContent,
	SheetDescription,
	SheetHeader,
	SheetTitle,
} from "@/shared/ui/sheet"
import { FilteredPeople } from "@/widgets/audience-list"

export interface BlockPeople {
	nodeId: string
	mode: "passed" | "stuck"
	label: string
}

/** Боковая панель воронки: кто прошёл блок или стоит на нём, при выбранной метке только её люди. */
export function BlockPeoplePanel({
	botId,
	target,
	utm,
	onModeChange,
	onClose,
}: {
	botId: string
	target: BlockPeople | null
	utm: string
	onModeChange: (mode: BlockPeople["mode"]) => void
	onClose: () => void
}) {
	const filter: AudienceFilter | null = target
		? {
				...(target.mode === "passed"
					? { passedNodeId: target.nodeId }
					: { stuckNodeId: target.nodeId }),
				...(utm ? { entryLink: utm } : {}),
			}
		: null

	return (
		<Sheet open={!!target} onOpenChange={(open) => !open && onClose()}>
			<SheetContent className="w-full overflow-y-auto sm:max-w-lg">
				<SheetHeader>
					<SheetTitle>Люди на блоке</SheetTitle>
					<SheetDescription className="line-clamp-2">
						{target?.label}
						{utm ? ` · только из метки ${utm}` : ""}
					</SheetDescription>
				</SheetHeader>
				{target && filter ? (
					<div className="space-y-4 px-4 pb-6">
						<SegmentedControl
							aria-label="Кого показать"
							value={target.mode}
							onChange={(mode) => mode && onModeChange(mode)}
							options={[
								{ value: "passed", label: "Прошли" },
								{ value: "stuck", label: "Стоят на блоке" },
							]}
						/>
						<FilteredPeople
							botId={botId}
							filter={filter}
							title={target.mode === "passed" ? "Прошли блок" : "Стоят на блоке"}
							emptyText="На этом блоке сейчас никого."
							broadcastName={`${target.mode === "passed" ? "Прошли" : "Стоят на"} «${target.label}»`}
						/>
					</div>
				) : null}
			</SheetContent>
		</Sheet>
	)
}
